import { AutorenewOffIcon } from './AutorenewOffIcon';

/**
 * author: Colton Wiscombe
 * id E140F6DB-8C47-4F0F-9293-0D8EE1106B64
 * name autorenew-off
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/autorenew-off.svg
 * tags
 * - Arrow 
 */
export const CircleArrowsOffIcon = AutorenewOffIcon;
export default CircleArrowsOffIcon